import styled from "styled-components";

export const InputSearchContainer = styled.div`
  display: flex;
  justify-content: space-between;

  input {
    width: 37rem;
    height: 2.25rem;
    margin-left: 2.5rem;
    padding-left: 1rem;
    border-radius: 5px;
    outline: none;
    border: none;
  }

  button {
    display: flex;
    align-items: center;
    justify-content: space-around;
    position: absolute;
    right: 0;
    width: 2.25rem;
    height: 2.25rem;
    border: none;
    background: none;
    margin: 6px;
    font-size: 1rem;
    color: rgba(112, 112, 112, 0.5);
  }

  @media (max-width: 1024px) {
    input {
      width: 20rem;
      margin-left: 1rem;
    }
  }

  @media (max-width: 768px) {
    input {
      width: 15rem;
    }
  }

  @media (max-width: 425px) {
    input {
      width: 100%;
      ::placeholder {
        font-size: 0.75rem;
      }
    }
  }
`;
